<div>
  <ks-dropdown [options]="twilightOptions" [(ngModel)]="twilight" [disabled]="twilightDisabled"></ks-dropdown>
</div>
